import { formatPhoneNumber } from 'src/utils/formatters/formatPhoneNumber';
import { PhoneConfiguration } from '../types';

export const NON_DIGITS = /[^\d]/g;

export const getPhoneNumber = (phoneNumber: string): PhoneConfiguration => {
    const digitsOnly = phoneNumber.replace(NON_DIGITS, '');
    const normalized = digitsOnly.startsWith('1') && digitsOnly.length === 11 ? digitsOnly.slice(1) : digitsOnly;
    return {
        asLink: `tel:+1${normalized}`,
        formatted: normalized ? formatPhoneNumber(normalized) : '',
    };
};
